import React, { Component } from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    TextField,
    IconButton,
    Button,
    Grid,
    Divider,
    Tab,
    Tabs,
    Paper,
    Tooltip,
    InputAdornment,
    Autocomplete,
    Chip,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Avatar,
    Stack,
    Alert,
    Badge,
    Collapse
} from '@mui/material';
import {
    DeleteOutlined as DeleteIcon,
    InventoryOutlined as InventoryIcon,
    CollectionsOutlined as CollectionsIcon,
    Check,
    AddPhotoAlternate as AddPhotoIcon,
    FlashOn as FastEditIcon,
    WarningAmberOutlined as AlertIcon,
    PaletteOutlined as ColorIcon,
    StraightenOutlined as SizeIcon
} from '@mui/icons-material';
import LayersIcon from '@mui/icons-material/Layers';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { apiUrl } from '../../comp/ApiUrl';
import { WithRouter } from '../../comp/WithRouter';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

class EditProductsAttributes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Atributos Selecionados
            selectedCores: ['Preto', 'Amarelo'],
            selectedTamanhos: ['P', 'M', 'G'],

            // Grade Gerada
            grade: [],

            // Edição em Lote
            bulkPrice: '',
            bulkEstoque: '',

            isSaving: false
        };
    }

    componentDidMount() {
        document.title = 'Grade de Produtos - Modas';
        this.carregarVariacoes();
    }

    formatBRL = (value) => {
        if (value === undefined || value === null || isNaN(value)) return "0,00";
        return Number(value).toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    };

    parseBRL = (value) => {
        if (!value) return 0;
        const cleanValue = String(value).replace(/\D/g, "");
        return parseFloat(cleanValue) / 100;
    };

    carregarVariacoes = async () => {
        try {
            const response = await fetch(`${apiUrl}/products/variations/${this.props.params.uuid}`, {
                method: "GET",
                credentials: "include",
                headers: { "Content-Type": "application/json" }
            });

            if (response.status === 200) {
                const data = await response.json();
                if (data.grade && data.grade.length > 0) {
                    this.setState({
                        selectedCores: data.selectedCores || [],
                        selectedTamanhos: data.selectedTamanhos || [],
                        grade: data.grade || []
                    });
                } else {
                    // Inicializa a grade com as seleções padrão
                    this.sincronizarGrade(['Preto', 'Amarelo'], ['P', 'M', 'G'], []);
                }
            } else {
                toast.error("Erro ao carregar variações do produto.");
            }
        } catch (error) {
            console.error("Erro ao buscar variações:", error);
            toast.error("Erro de conexão ao carregar variações.");
        }
    };

    // Sincroniza e regenera a grade dinamicamente sem perder dados alterados
    sincronizarGrade = (cores, tamanhos, gradeAtual = this.state.grade) => {
        const novaGrade = [];

        cores.forEach((cor) => {
            tamanhos.forEach((tamanho) => {
                const sku = `${cor.substring(0, 3).toUpperCase()}-${tamanho.toUpperCase()}`;

                // Mantém valores existentes caso a combinação já estivesse configurada
                const existente = gradeAtual.find(
                    (item) => item.cor.toLowerCase() === cor.toLowerCase() && item.tamanho.toLowerCase() === tamanho.toLowerCase()
                );

                if (existente) {
                    novaGrade.push(existente);
                } else {
                    novaGrade.push({
                        id: null,
                        cor,
                        tamanho,
                        sku,
                        quanty: 0,
                        price: 0.0,
                        image_url: ''
                    });
                }
            });
        });

        this.setState({ selectedCores: cores, selectedTamanhos: tamanhos, grade: novaGrade });
    };

    handleCoresChange = (event, newValue) => {
        this.sincronizarGrade(newValue, this.state.selectedTamanhos);
    };

    handleTamanhosChange = (event, newValue) => {
        this.sincronizarGrade(this.state.selectedCores, newValue);
    };

    handleGradeChange = (index, field, value) => {
        this.setState((prevState) => {
            const novaGrade = [...prevState.grade];
            novaGrade[index][field] = value;
            return { grade: novaGrade };
        });
    };

    handleRemoverItemGrade = (index) => {
        this.setState((prevState) => ({
            grade: prevState.grade.filter((_, i) => i !== index)
        }));
    };

    // AÇÕES EM MASSA (Facilita a vida do lojista)
    handleAplicarPrecoEmMassa = () => {
        const valorPuro = this.parseBRL(this.state.bulkPrice);
        if (valorPuro <= 0) return;

        this.setState((prevState) => ({
            grade: prevState.grade.map((item) => ({ ...item, price: valorPuro })),
            bulkPrice: ''
        }));
        toast.success("Preço aplicado a todas as variações!");
    };

    handleAplicarEstoqueEmMassa = () => {
        const qtdPura = parseInt(this.state.bulkEstoque, 10) || 0;
        this.setState((prevState) => ({
            grade: prevState.grade.map((item) => ({ ...item, quanty: qtdPura })),
            bulkEstoque: ''
        }));
        toast.success("Estoque aplicado a todas as variações!");
    };

    // Aplica a mesma imagem para todas as variações daquela cor especificada
    handleReplicarFotoPorCor = (corAlvo, urlFoto) => {
        if (!urlFoto) return;
        this.setState((prevState) => ({
            grade: prevState.grade.map((item) => (item.cor === corAlvo ? { ...item, image_url: urlFoto } : item))
        }));
        toast.info(`Foto replicada para todas as variações da cor "${corAlvo}".`);
    };

    handleSalvar = async () => {
        const toastId = toast.loading("Salvando alterações da grade...");
        this.setState({ isSaving: true });

        try {
            const response = await fetch(`${apiUrl}/products/set/v2/variations`, {
                method: "PUT",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    uuid: this.props.params.uuid,
                    selectedCores: this.state.selectedCores,
                    selectedTamanhos: this.state.selectedTamanhos,
                    grade: this.state.grade
                })
            });

            const data = await response.json();

            if (data.success) {
                toast.update(toastId, {
                    render: "Grade salva com sucesso!",
                    type: "success",
                    isLoading: false,
                    autoClose: 3000
                });
                this.carregarVariacoes();
            } else {
                throw new Error(data.error || "Erro ao salvar grade.");
            }
        } catch (error) {
            console.error("Erro ao salvar:", error);
            toast.update(toastId, {
                render: error.message || "Falha ao salvar a grade.",
                type: "error",
                isLoading: false,
                autoClose: 3000
            });
        } finally {
            this.setState({ isSaving: false });
        }
    };

    render() {
        const { selectedCores, selectedTamanhos, grade, isSaving, bulkPrice, bulkEstoque } = this.state;

        // Cálculos de resumo UX para o lojista
        const totalEstoque = grade.reduce((acc, curr) => acc + (parseInt(curr.quanty, 10) || 0), 0);
        const semEstoqueCount = grade.filter((item) => !item.quanty || item.quanty <= 0).length;

        return (
            <Box sx={{ p: { xs: 2, md: 4 }, backgroundColor: '#f8fafc', minHeight: '100vh' }}>
                {/* Cabeçalho */}
                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems={{ xs: 'flex-start', sm: 'center' }} spacing={2} sx={{ mb: 3 }}>
                    <Box>
                        <Typography variant="h5" fontWeight="700" color="text.primary">
                            Grade de Modas
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Gerencie tamanhos, cores e controle estoque/preço individual de cada variação.
                        </Typography>
                    </Box>
                    <Button
                        variant="contained"
                        onClick={this.handleSalvar}
                        disabled={isSaving}
                        startIcon={<Check />}
                        size="large"
                        sx={{
                            borderRadius: '10px',
                            textTransform: 'none',
                            px: 3,
                            bgcolor: '#7c3aed',
                            '&:hover': { bgcolor: '#6d28d9' }
                        }}
                    >
                        Salvar Alterações
                    </Button>
                </Stack>

                {/* Navegação por Abas */}
                <Box sx={{ mb: 4 }}>
                    <Tabs
                        value={3}
                        sx={{
                            '& .MuiTabs-indicator': { display: 'none' },
                            '& .MuiTab-root': {
                                textTransform: 'none',
                                minHeight: '40px',
                                borderRadius: '8px',
                                mr: 1,
                                fontWeight: 600,
                                color: '#64748b'
                            },
                            '& .Mui-selected': {
                                bgcolor: '#fff',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.06)',
                                color: '#7c3aed !important'
                            }
                        }}
                    >
                        <Tab component={Link} to={`/produtos/${this.props.params.uuid}/basic`} icon={<InventoryIcon />} iconPosition="start" label="Informações" />
                        <Tab component={Link} to={`/produtos/${this.props.params.uuid}/photos`} icon={<CollectionsIcon />} iconPosition="start" label="Fotos Galeria" />
                        <Tab component={Link} to={`/produtos/${this.props.params.uuid}/price`} icon={<AttachMoneyIcon />} iconPosition="start" label="Preço Base" />
                        <Tab component={Link} to={`/produtos/${this.props.params.uuid}/attributes`} icon={<LayersIcon />} iconPosition="start" label="Grade & Estoque" />
                    </Tabs>
                </Box>

                {/* 1. SELEÇÃO RÁPIDA DE CORES E TAMANHOS */}
                <Card sx={{ mb: 3, borderRadius: 3, border: '1px solid #e2e8f0', boxShadow: 'none' }}>
                    <CardContent sx={{ p: 3 }}>
                        <Typography variant="subtitle1" fontWeight="700" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                            <LayersIcon sx={{ color: '#7c3aed' }} /> Passo 1: Defina os Atributos da Peça
                        </Typography>

                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                    <ColorIcon fontSize="small" sx={{ color: '#64748b' }} />
                                    <Typography variant="body2" fontWeight="600">
                                        Cores do Modelo
                                    </Typography>
                                </Stack>
                                <Autocomplete
                                    multiple
                                    freeSolo
                                    options={['Preto', 'Branco', 'Azul Marinho', 'Vermelho', 'Amarelo', 'Verde Militar', 'Rosa Bebê', 'Off-White']}
                                    value={selectedCores}
                                    onChange={this.handleCoresChange}
                                    renderTags={(value, getTagProps) =>
                                        value.map((option, index) => (
                                            <Chip variant="filled" label={option} size="small" {...getTagProps({ index })} key={option} sx={{ bgcolor: '#f1f5f9', fontWeight: 600 }} />
                                        ))
                                    }
                                    renderInput={(params) => (
                                        <TextField {...params} size="small" placeholder="Escolha ou digite uma cor..." />
                                    )}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                    <SizeIcon fontSize="small" sx={{ color: '#64748b' }} />
                                    <Typography variant="body2" fontWeight="600">
                                        Tamanhos Disponíveis
                                    </Typography>
                                </Stack>
                                <Autocomplete
                                    multiple
                                    freeSolo
                                    options={['PP', 'P', 'M', 'G', 'GG', 'XG', '36', '38', '40', '42', '44', '46']}
                                    value={selectedTamanhos}
                                    onChange={this.handleTamanhosChange}
                                    renderTags={(value, getTagProps) =>
                                        value.map((option, index) => (
                                            <Chip variant="filled" label={option} size="small" {...getTagProps({ index })} key={option} sx={{ bgcolor: '#f1f5f9', fontWeight: 600 }} />
                                        ))
                                    }
                                    renderInput={(params) => (
                                        <TextField {...params} size="small" placeholder="Escolha ou digite o tamanho..." />
                                    )}
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>

                {/* 2. BARRA DE PREENCHIMENTO RÁPIDO / EDICAO EM MASSA */}
                {grade.length > 0 && (
                    <Paper elevation={0} sx={{ p: 2, mb: 3, borderRadius: 3, border: '1px dashed #cbd5e1', bgcolor: '#f1f5f9' }}>
                        <Typography variant="body2" fontWeight="700" sx={{ mb: 1.5, display: 'flex', alignItems: 'center', gap: 1, color: '#334155' }}>
                            <FastEditIcon sx={{ color: '#eab308' }} /> Ações em Lote (Preencha toda a grade de uma só vez):
                        </Typography>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} sm={5} md={4}>
                                <Stack direction="row" spacing={1}>
                                    <TextField
                                        size="small"
                                        placeholder="Preço igual p/ todos"
                                        value={bulkPrice}
                                        onChange={(e) => this.setState({ bulkPrice: e.target.value })}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                                        }}
                                        sx={{ bgcolor: '#fff', borderRadius: 1 }}
                                    />
                                    <Button variant="contained" color="secondary" onClick={this.handleAplicarPrecoEmMassa} sx={{ textTransform: 'none', whiteSpace: 'nowrap' }}>
                                        Aplicar Preço
                                    </Button>
                                </Stack>
                            </Grid>

                            <Grid item xs={12} sm={5} md={4}>
                                <Stack direction="row" spacing={1}>
                                    <TextField
                                        size="small"
                                        type="number"
                                        placeholder="Qtd. igual p/ todos"
                                        value={bulkEstoque}
                                        onChange={(e) => this.setState({ bulkEstoque: e.target.value })}
                                        sx={{ bgcolor: '#fff', borderRadius: 1 }}
                                    />
                                    <Button variant="contained" color="secondary" onClick={this.handleAplicarEstoqueEmMassa} sx={{ textTransform: 'none', whiteSpace: 'nowrap' }}>
                                        Aplicar Estoque
                                    </Button>
                                </Stack>
                            </Grid>
                        </Grid>
                    </Paper>
                )}

                {/* 3. TABELA DE GRADE E COMBINAÇÕES */}
                {grade.length > 0 ? (
                    <Card sx={{ borderRadius: 3, border: '1px solid #e2e8f0', boxShadow: 'none' }}>
                        <CardContent sx={{ p: 3 }}>
                            <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems={{ xs: 'flex-start', sm: 'center' }} sx={{ mb: 2 }}>
                                <Typography variant="subtitle1" fontWeight="700">
                                    Passo 2: Monte e Revise a Grade ({grade.length} Variações)
                                </Typography>
                                <Stack direction="row" spacing={2} sx={{ mt: { xs: 1, sm: 0 } }}>
                                    <Chip label={`Estoque Total: ${totalEstoque} un`} color="primary" variant="outlined" sx={{ fontWeight: 600 }} />
                                    {semEstoqueCount > 0 && (
                                        <Chip icon={<AlertIcon />} label={`${semEstoqueCount} sem estoque`} color="warning" sx={{ fontWeight: 600 }} />
                                    )}
                                </Stack>
                            </Stack>

                            <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #e2e8f0', borderRadius: 2 }}>
                                <Table size="medium">
                                    <TableHead sx={{ bgcolor: '#f8fafc' }}>
                                        <TableRow>
                                            <TableCell><strong>Foto da Cor</strong></TableCell>
                                            <TableCell><strong>Combinação</strong></TableCell>
                                            <TableCell width="200"><strong>Estoque (Qtd)</strong></TableCell>
                                            <TableCell width="220"><strong>Preço Venda (R$)</strong></TableCell>
                                            <TableCell width="60" align="center"><strong>Ação</strong></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {grade.map((item, index) => (
                                            <TableRow key={`${item.cor}-${item.tamanho}-${index}`} hover sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                {/* Foto com Atalho para Replicar por Cor */}
                                                <TableCell>
                                                    <Stack direction="row" alignItems="center" spacing={1}>
                                                        <Avatar src={item.image_url} variant="rounded" sx={{ width: 44, height: 44, bgcolor: '#f1f5f9', border: '1px solid #e2e8f0' }}>
                                                            <AddPhotoIcon sx={{ color: '#94a3b8', fontSize: 22 }} />
                                                        </Avatar>
                                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                                            <TextField
                                                                placeholder="URL Imagem"
                                                                size="small"
                                                                value={item.image_url || ''}
                                                                onChange={(e) => this.handleGradeChange(index, 'image_url', e.target.value)}
                                                                sx={{ width: 150, '& input': { fontSize: '11px' } }}
                                                            />
                                                            {item.image_url && (
                                                                <Typography
                                                                    variant="caption"
                                                                    sx={{ color: '#7c3aed', cursor: 'pointer', fontWeight: 600, fontSize: '10px' }}
                                                                    onClick={() => this.handleReplicarFotoPorCor(item.cor, item.image_url)}
                                                                >
                                                                    Copiar foto para todo {item.cor}
                                                                </Typography>
                                                            )}
                                                        </Box>
                                                    </Stack>
                                                </TableCell>

                                                {/* Identificador Visual da Peça */}
                                                <TableCell>
                                                    <Stack spacing={0.5}>
                                                        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                                            <Chip label={item.cor} size="small" sx={{ bgcolor: '#e0e7ff', color: '#3730a3', fontWeight: 700 }} />
                                                            <Chip label={item.tamanho} size="small" sx={{ bgcolor: '#f3e8ff', color: '#6b21a8', fontWeight: 700 }} />
                                                        </Box>
                                                        <Typography variant="caption" color="text.secondary">
                                                            SKU: {item.sku}
                                                        </Typography>
                                                    </Stack>
                                                </TableCell>

                                                {/* Estoque */}
                                                <TableCell>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        type="number"
                                                        value={item.quanty}
                                                        onChange={(e) => this.handleGradeChange(index, 'quanty', parseInt(e.target.value, 10) || 0)}
                                                        inputProps={{ min: 0 }}
                                                        error={!item.quanty || item.quanty <= 0}
                                                    />
                                                </TableCell>

                                                {/* Preço */}
                                                <TableCell>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        value={this.formatBRL(item.price)}
                                                        onChange={(e) => {
                                                            const numericValue = this.parseBRL(e.target.value);
                                                            this.handleGradeChange(index, 'price', numericValue);
                                                        }}
                                                        InputProps={{
                                                            startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                                                        }}
                                                    />
                                                </TableCell>

                                                {/* Remover Variação */}
                                                <TableCell align="center">
                                                    <Tooltip title="Excluir esta combinação">
                                                        <IconButton size="small" color="error" onClick={() => this.handleRemoverItemGrade(index)}>
                                                            <DeleteIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </CardContent>
                    </Card>
                ) : (
                    <Alert severity="info" sx={{ borderRadius: 2 }}>
                        Selecione pelo menos uma <strong>Cor</strong> e um <strong>Tamanho</strong> acima para ver a grade de produtos ser gerada automaticamente.
                    </Alert>
                )}
            </Box>
        );
    }
}

export default WithRouter(EditProductsAttributes);